// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__2AHav","inner":"footer_inner__3jMjf","link":"footer_link__3DR_s","widgets":"footer_widgets__2evyV","copyright":"footer_copyright__3OqnL"};